import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { ISession } from '../../../models/session';
import { ICalendarContent } from '../../../models/calendarContent';
import { IcsService } from '../../sessions/ics.service';

@Component({
  selector: 'edit-ics-content',
  templateUrl: './edit-ics-content.component.html',
})
export class EditIcsContentComponent implements OnInit {
  @Input() session: ISession;

  public readonly SUMMARY_MAX = 250;
  public readonly DESCRIPTION_MAX = 2000;
  public readonly LOCATION_MAX = 250;

  public form = this.fb.group({
    summary:     ['', [Validators.required, Validators.maxLength(this.SUMMARY_MAX)]],
    description: ['', [Validators.maxLength(this.DESCRIPTION_MAX)]],
    location:    ['', [Validators.maxLength(this.LOCATION_MAX)]],
  });

  public isLoading = false;
  public isSaving = false;

  private contentId: number | null = null;

  constructor(
    private readonly fb: FormBuilder,
    private readonly icsService: IcsService,
    private readonly translateService: TranslateService,
  ) {}

  ngOnInit() {
    this.load();
  }

  public load() {
    if (!this.session) return;
    this.isLoading = true;
    this.icsService.getCalendarContent(this.session).subscribe(
      (data: ICalendarContent) => {
        this.contentId = data ? data.id : null;
        this.form.reset({
          summary:     (data && data.summary)     || '',
          description: (data && data.description) || '',
          location:    (data && data.location)    || '',
        });
        this.isLoading = false;
      },
      _err => {
        toastr.error(this.translateService.instant('action.failed'));
        this.isLoading = false;
      }
    );
  }

  public save() {
    if (this.form.invalid) return;
    this.isSaving = true;
    const content: ICalendarContent = { id: this.contentId, ...this.form.value };
    this.icsService.saveCalendarContent(this.session, content).subscribe(
      (data: ICalendarContent) => {
        this.contentId = data ? data.id : this.contentId;
        this.form.markAsPristine();
        this.isSaving = false;
      },
      _err => {
        toastr.error(this.translateService.instant('action.failed'));
        this.isSaving = false;
      }
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/email/edit-ics-content/edit-ics-content.component.ts